import { movementTypeTermOp } from './../../../core/models/enums/movementTypeTermOp';
import { TranslatorService } from './../../../core/services/translator/translator.service';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { Subscription } from 'rxjs';
import { MasterCreateProfileComponent } from './../master-create-profile/views/permissoes/master-create-profile.component';
import { ConfirmBoxColor } from './../../../custom-shared/components/alerts/confirm-box/confirm-box.component';
import { DialogBoxService } from './../../../custom-shared/components/alerts/dialog-box-service';
import { MasterVisualizarPerfilService } from './master-visualizar-perfil.service';
import { Profile, Permission } from './master-visualizar-perfil.model';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MasterEditarPerfilAcessoComponent } from '../editar-perfil-acesso/master-editar-perfil-acesso.component';

@Component({
  selector: 'app-master-visualizar-perfil',
  templateUrl: './master-visualizar-perfil.component.html',
  styleUrls: ['./master-visualizar-perfil.component.scss'],
})
export class MasterVisualizarPerfilComponent implements OnInit {
  hasEditPermission: boolean = false;
  hasCreatePermission: boolean = false;
  hasDeletePermission: boolean = false;
  hasReportsPermission:boolean = false;
  panelOpenState;
  subscription: Subscription;
  description: string;

  id: any;
  profile: Profile;

  isOpen = false;

  dialogConfig: any;

  selected = 0;
  movementPermissions:any
  positionPermissions:any
  otherReportPermissions:any
  operationPermissions: Permission[] = new Array<Permission>();
  reportPermissions: Permission[] = new Array<Permission>();
  systemPermissions: Permission[] = new Array<Permission>();
  relatoriosPermissions: Permission[] = new Array<Permission>();
  constructor(
    private customAuthenticationService: CustomAuthenticationService,
    private masterVisualizarPerfilService: MasterVisualizarPerfilService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MasterVisualizarPerfilComponent>,
    private dialogBoxService: DialogBoxService,
    private translatorService : TranslatorService
  ) { }

  ngOnInit() {
    this.checkPermissions();
    this.getProfile();
  }

  

  getProfile() {
    const payload = {id:this.id};
    const observable = this.masterVisualizarPerfilService.getProfile(payload);
    this.subscription = observable.subscribe(response => {
      // debugger;
      this.profile = response;

      this.operationPermissions = this.profile.roles.filter(
        r => r.typePermission === 'Permissões de operação',
      );
      this.systemPermissions = this.profile.roles.filter(
        r => r.typePermission === 'Permissões de sistema',
      );
      this.reportPermissions = this.profile.roles.filter(
        r => r.typePermission === 'Permissões de relatório',
      );
      this.relatoriosPermissions  = this.profile.roles.filter(
        r => r.typePermission === 'Relatorios',
      );
      this.movementPermissions= this.relatoriosPermissions.filter(p => p.namePermission.startsWith('MOVEMENT'));
      this.positionPermissions= this.relatoriosPermissions.filter(p => p.namePermission.startsWith('POSICAO') || p.namePermission.startsWith('POSITION'));
      this.otherReportPermissions= this.relatoriosPermissions.filter(p => p.namePermission.startsWith('OTHER'));
      
      this.hasReportsPermission = this.reportPermissions?.some(
        permission => permission.namePermission === 'Relatórios'
      );
    });
  }

  
  // getLength(arr: Array<any>) {
  //   if(arr == undefined){
  //     return 0
  //   }
  //   if (arr !== null ) {
  //     return arr.length;
  //   }
  //   return 0;
  // }
  openDialogEditProfile(profile: Profile) {
    const user = {
      id: profile.id,
      profile: profile.name,
      description: this.description ? this.description : '',
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '90vh';
    dialogConfig.width = '92vw';
    dialogConfig.maxWidth = '100vw';
    const dialogRef = this.dialog.open(
      MasterEditarPerfilAcessoComponent,
      dialogConfig,
    );
    dialogRef.componentInstance.user = user;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getProfile();
      }
    });
  }
  duplicateProfile() {
    let title,msg,cancel,duplicate:string
    title=this.translatorService.translateConfirmBox('titleDuplicateAccessProfile')
    msg=this.translatorService.translateConfirmBox('msgDupAccessProfile')
    cancel=this.translatorService.translateConfirmBox('cancelConfirm')
    duplicate=this.translatorService.translateConfirmBox('okDuplicate')

    this.dialogBoxService
      .confirmBox({
        lblTitle: title,
        lblSubtitle:msg,
        lblCancelButton: cancel,
        lblConfirmButton: duplicate,
        color: ConfirmBoxColor.error,
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.profile.name = this.profile.name + ' - Cópia';
          this.masterVisualizarPerfilService
            .postDuplicateProfile(this.profile)
            .subscribe();
          this.doClose();
        }
      });
  }

  deleteProfile() {
    let title,msg,cancel,confirm:string
    title=this.translatorService.translateConfirmBox('deleteAccessProfileTitle')
    msg=this.translatorService.translateConfirmBox('deletesUsersProfiles')
    cancel=this.translatorService.translateConfirmBox('CancelConfirm')
    confirm=this.translatorService.translateConfirmBox('okDelete')

    this.dialogBoxService
      .confirmBox({
        lblTitle: title,
        lblSubtitle:msg,
        lblCancelButton: cancel,
        lblConfirmButton: confirm,
        color: ConfirmBoxColor.error,
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.masterVisualizarPerfilService
            .deleteProfile(this.profile.id)
            .subscribe(res=>{
              this.doClose()
            })
        }
      });
  }

  checkPermissions() {
    this.hasEditPermission = this.customAuthenticationService.hasPermission(
      'Editar perfil de acesso',
    )
      ? true
      : false;
    this.hasCreatePermission = this.customAuthenticationService.hasPermission(
      'Criar Perfil de acesso',
    )
      ? true
      : false;
    this.hasDeletePermission = this.customAuthenticationService.hasPermission(
      'Excluir perfil de acesso',
    )
      ? true
      : false;
  }

  doClose() {
    this.subscription.unsubscribe();
    this.dialogRef.close();
  }

  changeTab() {
    this.selected = this.selected + 1;
  }

  openMenu() {
    this.isOpen = !this.isOpen;
  }
}
